import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '../resources/config';

interface SaviyntResults {
  status: string;
  statusCode: string;
  msg: string;
}
@Injectable()
export class SaviyntService {
  public errorMessage: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: any,
  ) {}

  saviyntUniquenessCheck({ firstName, lastName, dob, zipCode }) {
    const payload = {
      firstname: firstName,
      lastname: lastName,
      customerproperty7: dob,
      customerproperty5: zipCode,
    };
    return this.http.post<SaviyntResults>(
      this.config.userSavUnqChkPath,
      payload,
    );
  }
}
